import { createSlice } from "@reduxjs/toolkit";

const findSlice = createSlice({
  name: "find",
  initialState: "",

  reducers: {
    findContact: {
      reducer(state, action) {
        return action.payload;
      },

      prepare(name) {
        return {
          payload: name,
        };
      },
    },
  },
});

export const { findContact } = findSlice.actions
export const findReducer = findSlice.reducer
